import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

export const nbrbServiceStatus = async (): Promise<null | boolean> => {
  const response = await customFetch(getM8AdminURL('nbrbServiceStatus'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return true;
  }

  if (response.status === 204) {
    return false;
  }

  return null;
};
